// import AppListing from '../app-components/Listing/AppListing';

Vue.component('tabs-listing', {
    // mixins: [AppListing],
    emits:['tab-upload-content'],
    data: function() {
        return {
            tabSelected : 'tab-list-transaksi',
            fileSelected : null,
            tabUploadContent : 'listing',
        }
    },
    methods: {
        hasActive (tab){
            return this.tabSelected==tab?'active':''
        },
        successfulUploadHandler (result){
            // console.log('successfulUploadHandler', result)
            // console.log('result.id', result.id)
            this.fileSelected = result.id
            // console.log('this.fileSelected', this.fileSelected)
        },
        selectFile (data){
            // console.log('successfulUploadHandler', result)
            // console.log('result.id', result.id)
            // this.fileSelected = result.id
            // console.log('this.fileSelected', this.fileSelected)
        },
        tabUploadContentHandler (data){
            this.tabUploadContent=data
            // console.log('successfulUploadHandler', result)
            // console.log('result.id', result.id)
            // this.fileSelected = result.id
            // console.log('this.fileSelected', this.fileSelected)
        }
    },
    watch: {
        fileSelected(newfileSelected, oldfileSelected) {
            if (newfileSelected>0) {
                this.tabSelected = 'tab-form-import'
            }
        }
    },

});